<template>
  <div class="attainment">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>素养考核</b>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="classChapterId"
          :options="chapters"
          @change="getList"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>
        <!-- <el-select
          v-model="classChapterId"
          placeholder="请选择章节"
          size="mini"
          @change="getList"
        >
          <el-option-group
            v-for="group in chapters"
            :key="group.classChapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </div>
      <div class="btn export_btn" @click="onExport">
        导出数据 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="main">
      <div class="box_title">素养考核分数排名</div>
      <div class="rank_box">
        <div
          class="one"
          v-for="item in list"
          :key="item.userId"
          @click="goDetail(item.userId)"
        >
          <span class="score" :style="{ bottom: item.score * 0.85 + '%' }"
            >{{ item.score || 0 }}分</span
          >
          <div class="zhu" :style="{ height: item.score * 0.8 + '%' }"></div>
          <span class="name">{{ item.nickName }}</span>
        </div>
      </div>

      <div class="score_row">
        <div class="score_box">
          <p class="score_title">最高分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="highest"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
        <div class="score_box">
          <p class="score_title">平均分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="average"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
        <div class="score_box">
          <p class="score_title">最低分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="lowest"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { userSyScoreList } from "@/api/evaluation";
import { handleTree, getArrayStatistic } from "@/utils";

export default {
  data() {
    return {
      getArrayStatistic,
      classChapterId: null,
      chapters: [],
      list: [],
      show: false,
    };
  },
  created() {
    this.getChapterList();
  },
  computed: {
    highest() {
      return this.getArrayStatistic(this.list, "score", "max");
    },
    lowest() {
      return this.getArrayStatistic(this.list, "score", "min");
    },
    average() {
      return this.getArrayStatistic(this.list, "score", "avg");
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
          if (this.chapters[0].children[0].children) {
            this.classChapterId =
              this.chapters[0].children[0].children[0].classChapterId;
          } else {
            this.classChapterId = this.chapters[0].children[0].classChapterId;
          }
          this.getList();
        } else {
          console.log(res.msg);
        }
      });
    },
    getList() {
      this.$loading.show();
      userSyScoreList({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
          this.show = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    format(percentage) {
      return percentage + " ";
    },
    goDetail(userId) {
      this.$router.push({
        path: "/classCourse/evaluation/attainment/detail",
        query: {
          ...this.$route.query,
          userId,
          classChapterId: this.classChapterId,
        },
      });
    },
    // 导出
    onExport() {
      let token = localStorage.getItem("token");
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/sy/export?classId=${this.$route.query.id}&classChapterId=${this.classChapterId}&Authorization=${token}`
      );
    },
  },
};
</script>


<style lang="less" scoped>
.attainment {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.chapter_btn {
        left: 0;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 20px 2px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      text-align: left;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .rank_box {
      padding: 24px 30px 44px;
      height: 307px;
      box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
      text-align: left;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }

      .one {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 240px;
        text-align: center;
        vertical-align: bottom;
        &:not(:last-child) {
          margin-right: 28px;
        }
        &:hover {
          .zhu {
            transform: scaleX(1.2);
          }
        }
        .score {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 17px;
          font-size: 16px;
          color: #6be015;
          transition: all 0.3s ease;
        }
        .zhu {
          position: absolute;
          bottom: 0;
          margin: 15px 0;
          width: 100%;
          background-color: #6be015;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .name {
          position: absolute;
          left: 50%;
          bottom: -20px;
          transform: translateX(-50%);
          color: #65c6e7;
          font-size: 15px;
        }
      }
    }
    .score_row {
      margin-top: 15px;
      .score_box {
        display: inline-block;
        width: 390px;
        &:not(:last-child) {
          margin-right: 10px;
        }
        .score_title {
          padding: 0 10px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #1de0fe;
          background-color: rgba(49, 70, 125, 0.1);
          // border: solid 1px rgba(4, 20, 40, 0.1);
          box-shadow: #1de0fe 0px 0px 5px inset;
        }
        .circle_box {
          position: relative;
          padding-top: 43px;
          height: 190px;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            color: #aae476;
            font-size: 30px !important;
          }
          .text {
            position: absolute;
            top: 47%;
            right: 42%;
            color: #aae476;
          }
        }
      }
    }
  }
}
</style>